import React from "react";
import Container from "../components/Container";
import ContactForm from "../components/Form/ContactForm";
import ContactCards from "../components/Contact/ContactCards";

const Homepage = () => {
  return (
    <>
      <div>
        <h1 className="text-white font-bold text-center bg-primary py-8">اتصل بنا</h1>
      </div>
      <Container>
        <div className="mb-14 md:mb-16">
          <ContactForm />
        </div>
        <ContactCards />
      </Container>
    </>
  );
};

export default Homepage;
